var map = {
	"./avaka": "./app/javascript/images/avaka.png",
	"./avaka.png": "./app/javascript/images/avaka.png",
	"./avaka_juodas": "./app/javascript/images/avaka_juodas.svg",
	"./avaka_juodas.svg": "./app/javascript/images/avaka_juodas.svg",
	"./avaka_logo": "./app/javascript/images/avaka_logo.png",
	"./avaka_logo.png": "./app/javascript/images/avaka_logo.png",
	"./avaka_mini": "./app/javascript/images/avaka_mini.png",
	"./avaka_mini.png": "./app/javascript/images/avaka_mini.png",
	"./elements/Elemntas": "./app/javascript/images/elements/Elemntas.svg",
	"./elements/Elemntas.svg": "./app/javascript/images/elements/Elemntas.svg",
	"./elements/Elemntas_1": "./app/javascript/images/elements/Elemntas_1.svg",
	"./elements/Elemntas_1.svg": "./app/javascript/images/elements/Elemntas_1.svg",
	"./elements/Elemntas_10": "./app/javascript/images/elements/Elemntas_10.svg",
	"./elements/Elemntas_10.svg": "./app/javascript/images/elements/Elemntas_10.svg",
	"./elements/Elemntas_2": "./app/javascript/images/elements/Elemntas_2.svg",
	"./elements/Elemntas_2.svg": "./app/javascript/images/elements/Elemntas_2.svg",
	"./elements/Elemntas_3": "./app/javascript/images/elements/Elemntas_3.svg",
	"./elements/Elemntas_3.svg": "./app/javascript/images/elements/Elemntas_3.svg",
	"./elements/Elemntas_4": "./app/javascript/images/elements/Elemntas_4.svg",
	"./elements/Elemntas_4.svg": "./app/javascript/images/elements/Elemntas_4.svg",
	"./elements/Elemntas_5": "./app/javascript/images/elements/Elemntas_5.svg",
	"./elements/Elemntas_5.svg": "./app/javascript/images/elements/Elemntas_5.svg",
	"./elements/Elemntas_6": "./app/javascript/images/elements/Elemntas_6.svg",
	"./elements/Elemntas_6.svg": "./app/javascript/images/elements/Elemntas_6.svg",
	"./elements/Elemntas_8": "./app/javascript/images/elements/Elemntas_8.svg",
	"./elements/Elemntas_8.svg": "./app/javascript/images/elements/Elemntas_8.svg",
	"./elements/Elemntas_9": "./app/javascript/images/elements/Elemntas_9.svg",
	"./elements/Elemntas_9.svg": "./app/javascript/images/elements/Elemntas_9.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";